import { StyledUsercentricsTrigger } from './UsercentricsTrigger.styled';
import CookieSvg from 'assets/icons/cookie.svg';
import { showUsercentricsSecondLayer } from 'utils/usercentrics';

const UsercentricsTrigger = () => {
  return (
    <StyledUsercentricsTrigger onClick={showUsercentricsSecondLayer}>
      <CookieSvg />
    </StyledUsercentricsTrigger>
  );
};

export default UsercentricsTrigger;
